import React, { memo, useState } from 'react';
import Questions, { getIcon, useDeleteQuestion } from '../../lib/Questions';
import Question from './Question';
import { Cog6ToothIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import ThemedForm from './ThemedForm.jsx';
import IconSort from '~/components/icons/IconSort.jsx';



const EditableQuestion = ({
    question,
    formId,
    formStyles,
    isThankYou,
    isActive,
    isEditing,
    onEditQuestion,
    onAddQuestion,
    showAddOnBottom,
    onDeleteQuestion,
    setSettings,
}) => {
    const questionSchema = Questions[question.type];
    const Icon = getIcon(questionSchema);
    const [value, setValue] = useState();
    const { saveDelete, isDeleting } = useDeleteQuestion(formId, question);
    const isVariableMultiday = question.type === 'scheduling' && (question.settings?.stepsOrder === 'event' || question.settings?.variableMultiday === true);

    function doDelete()
    {
        if (typeof onDeleteQuestion === 'function') {
            onDeleteQuestion(question);
        } else {
            saveDelete();
        }
    }

    if (!questionSchema) {
        return <div>Unknown question type {question.type}</div>;
    }

    return (
        <div className="editable-question-container">
            {!showAddOnBottom && (
                <div className="group pt-4">
                    <div className="flex justify-center opacity-0 max-h-0 overflow-hidden transition-all group-hover:max-h-24 group-hover:opacity-100">
                        <button
                            className="btn-light-pill flex items-center text-sm mb-4"
                            onClick={() => onAddQuestion(question.id, question)}
                        >
                            <PlusIcon className="h-4 w-4 mr-2" />
                            Add
                        </button>
                    </div>
                </div>
            )}
            <div
                className={`${isEditing ? 'border-primary-700' : 'border-white'} ${isActive ? 'opacity-60 border-gray-500' : ''} relative rounded border  group hover:border-primary-700 border-dashed cursor-pointer`}
                onClick={() => onEditQuestion(question)}
            >
                <div
                    className={`hidden group-hover:flex hover:flex absolute -right-14 pl-2 h-full flex-col items-end justify-center`}
                >
                    <div className="bg-white shadow-lg p-1 rounded-full flex items-center justify-center gap-x-2">
                        <div className="rounded-full hover:bg-gray-100 p-1 ">
                            <Cog6ToothIcon className="w-5 h-5 text-gray-700" />
                        </div>
                        <div className="rounded-full hover:bg-red-100 p-1" onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            doDelete();
                        }}>
                            <TrashIcon className="w-5 h-5 text-red-600" />
                        </div>
                    </div>
                </div>
                <div
                    className={`hidden group-hover:flex hover:flex absolute -left-10 pr-2 h-full flex-col items-end justify-center`}
                >
                    <div className="bg-white shadow-lg p-2 rounded-full flex items-center justify-center cursor-grab">
                        <div
                            className={`${isEditing ? 'block' : 'hidden'} group-hover:block`}
                        >
                            <IconSort className="w-5 h-5 text-gray-700" />
                        </div>
                    </div>
                </div>
                <div className={isVariableMultiday ? 'p-4' : 'p-6'}>
                    <ThemedForm styles={formStyles} scopeRoot={false}>
                        <Question
                            isReadOnly={true}
                            key={question.id}
                            question={question}
                            value={value}
                            setValue={setValue}
                            setSettings={setSettings}
                            mode="preview"
                        />
                    </ThemedForm>
                </div>
            </div>
            {!!showAddOnBottom && (
                <div className="group pt-4">
                    <div className="flex justify-center opacity-0 max-h-0 overflow-hidden transition-all group-hover:max-h-24 group-hover:opacity-100">
                        <button
                            className="btn-light-pill flex items-center text-sm mb-4"
                            onClick={() => onAddQuestion(question.id, question)}
                        >
                            <PlusIcon className="h-4 w-4 mr-2" />
                            Add
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

//export default EditableQuestion;
export default memo(EditableQuestion);
